"use client"
import { CookiesProvider } from "react-cookie"

// 修复 react-cookie 在某些环境（如钉钉、企业微信）中的 bug
// 问题：window.cookieStore 存在但值为 null，导致 addEventListener 报错
if (typeof window !== 'undefined') {
  // 在模块加载时立即执行修复
  if ('cookieStore' in window && window.cookieStore === null) {
    try {
      // 尝试删除 null 值的 cookieStore 属性
      delete (window as any).cookieStore;
      console.log('✅ 已修复 cookieStore null 值问题（钉钉/企业微信兼容性）');
    } catch (e) {
      // 如果无法删除（属性不可配置），则提供一个 polyfill
      console.warn('⚠️ cookieStore 属性不可删除，使用 polyfill');
      (window as any).cookieStore = {
        addEventListener: () => {
          console.log('📝 cookieStore.addEventListener polyfill called');
        },
        removeEventListener: () => {
          console.log('📝 cookieStore.removeEventListener polyfill called');
        },
      };
    }
  }
}

export default function CookiesProvder({ children }: { children: React.ReactNode }) {
  return <CookiesProvider>
    {children}
  </CookiesProvider>
}
